import { render, staticRenderFns } from "./shopmanage.vue?vue&type=template&id=f7a6dd90&scoped=true&"
import script from "./shopmanage.vue?vue&type=script&lang=js&"
export * from "./shopmanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a6dd90",
  null
  
)

export default component.exports